export const ROUTES = {
  HOME: '/',
  PROJECTS: '/projects',
};
